import React from 'react';
import PublicPolicyPage from 'src/components/public-policy-page';

const CookiePolicy: React.FC = () => (
  <PublicPolicyPage
    title="Cookie Policy"
    scriptSrc="https://app.enzuzo.com/scripts/cookies/02e5dbd2-1809-11f1-897f-f394f6e7fda1"
  />
);

export default CookiePolicy;
